import React, { useEffect, useState } from "react";

import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import { Toast } from "../../Component/Toast";
import Loader from '../../Component/Loader';
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";

const AppTime = () => {


  const { kv, set } = useStoreKv();
  const appTime = kv.apptime || [];

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(null);
  const [popup, setPopup] = useState(false);
  const [selectedLot, setSelectedLot] = useState(null);
  const [updating, setUpdating] = useState(false);
  const [lots, setLots] = useState(appTime);

  const getList = async () => {
    if (!kv.apptime || kv.apptime.length === 0) {
      setLoading(true);
    }
    const res = await get(URLS.APPTIME);
//     console.log("res AppTime list", res);
    if (res.status === "success") {
      setLots(res?.data);
      set("apptime", res?.data);
    } else {
      setLots([]);
      set("apptime", []);
    }
    setLoading(false);
  };

  useEffect(() => {
    getList();
  }, []);

  // ---------- FIXED: Correct field names ----------
  const handleChange = (id, field, value) => {
    setLots((prev) =>
      prev.map((lot) =>
        lot.id === id ? { ...lot, [field]: value } : lot
      )
    );
  };

  // ---------- FIXED: Updated correct API structure ----------
  const handleUpdate = async (lot) => {
    setUpdating(true);
    setLoading2(lot?.id)
    const payload = {
      id: lot.id,
      lot_time: lot.lot_time,
      lot_closing_time: lot.lot_closing_time,
      booking_closing_time: lot.booking_closing_time,
    };

//     console.log("Final Payload:", payload);
    // setLoading2(true);
    const res = await post(URLS.APPTIME, payload);
//     console.log("res post app time", res);

    if (res.status === "success") {
      Toast("Time Slot Updated Successfully");
      setLoading2(false);
      setUpdating(false);
      setPopup(false);
    } else {
      setLoading2(false);
      setUpdating(false);
    }
  };

  return (
    <div className="dashRightView d-flex ac-jb flex-column">
      <CustomScroll >
        <div style={{ paddingBottom: 80 }} className="container_overalls">
          {lots.map((lot) => (
            <div key={lot.id} className="mb-3">

              {/* Heading */}
              <div className="d-flex ac-js col-md-5 my-2">
                <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                  {`${lot?.name === "Kerala" ? "Kerala" : "Dear"} ${lot?.lot_time}`}
                </label>
              </div>

              {/* Time Inputs */}
              <div className="col-md-5">
                <div className="col-md-5 my-1 mt-2 sale_value">
                  <div className="table-like2">

                    {/* Header Row */}
                    <div className="table-row2">
                      <div className="table-cell3 text-center white f3 fs-xs-14">
                        Lot Time
                      </div>
                      <div className="table-cell3 text-center white f3 fs-xs-14">
                        Lot Closing
                      </div>
                      <div className="table-cell4 text-center white f3 fs-xs-14">
                        Booking Closing
                      </div>
                    </div>

                    {/* Input Row */}
                    <div className="table-row3">

                      {/* Lot Time Input */}
                      <div className="table-cell3 text-center fs-xs-14">
                        <input
                          type="text"
                          value={lot?.lot_time || ""}
                          onChange={(e) =>
                            handleChange(lot.id, "lot_time", e.target.value)
                          }
                          placeholder="hh:mm:ss AM/PM"
                          style={{ backgroundColor: "#F0EDE6", maxWidth: 90, }}
                          className="no-arrow border-0 text-center f2 fs-xs-13 placholdercolorchanges2"
                        />
                      </div>

                      {/* Lot Closing */}
                      <div className="table-cell3 text-center fs-xs-14">
                        <TimePicker
                          value={lot?.lot_closing_time || ""}
                          onChange={(value) =>
                            handleChange(lot.id, "lot_closing_time", value)
                          }
                          disableClock
                          format="hh:mm:ss a"
                          maxDetail="second"
                          clearIcon={null}
                          className="no-arrow border-0 text-center f2 fs-xs-14"
                        />
                      </div>

                      {/* Booking Closing */}
                      <div className="table-cell4 text-center fs-xs-14">
                        <TimePicker
                          value={lot?.booking_closing_time || ""}
                          onChange={(value) =>
                            handleChange(lot.id, "booking_closing_time", value)
                          }
                          disableClock
                          format="hh:mm:ss a"
                          maxDetail="second"
                          clearIcon={null}
                          className="no-arrow border-0 text-center f2 fs-xs-14"
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              {/* Update Button */}
              <div className="col-md-5 mt-2 mb-4">
                <button
                  className="add-button white w-100 f4 fs-xs-15"
                  onClick={() => { setSelectedLot(lot); setPopup(true); }}
                >
                  {(loading2 == lot.id) ? <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white" }}
                    ></span>
                  </> : 'Update'}
                </button>
              </div>

            </div>
          ))}

          {loading && <Loader />}
          {popup && (
            <div className="img-popup-design">
              <div className="img-popup">
                <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                  Are you sure you want to Update?
                </p>
                <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2  f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                  <button onClick={() => setPopup(false)} className="no-btn w-40">
                    No
                  </button>
                  <button
                    onClick={() => handleUpdate(selectedLot)}
                    className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                  >
                    {updating ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          style={{ color: "white", padding: 8 }}
                        ></span>
                      </>
                    ) : (
                      <span style={{ top: -1.5, position: 'relative' }}>Yes</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </CustomScroll >
    </div>
  );
};

export default AppTime;
